import * as classNames from 'classnames'
import * as React from 'react'
import { match } from 'react-router'
import { Link, Route, Switch } from 'react-router-dom'
import MembershipSettings from '../../containers/membership-request/MembershipSettings'
import { IProgramServiceMembership } from '../../types/membership'
import Search from '../icons/ui/Search'
import NewRequestsTable from './NewRequestsTable'
import ProcessedRequestsTable from './ProcessedRequestsTable'

export interface IMembershipProps {
  activeRequestType: string
  getMembershipNewRequests: (organizationId: string, page?: number) => void
  getMembershipProcessedRequests: (organizationId: string) => void
  isModalOpen: boolean
  items: IProgramServiceMembership[]
  toggleMembershipModal: any
  match: match<any>
  location: Location
  currentOrgId?: string
}

export interface IMembershipState {
  isModalOpen: boolean
}

class Membership extends React.Component<IMembershipProps, IMembershipState> {
  constructor(props: IMembershipProps) {
    super(props)
    this.state = {
      isModalOpen: false
    }
  }

  public NewRequestsTableWrap = () => (
    <NewRequestsTable
      currentOrgId={this.props.currentOrgId}
      items={this.props.items}
      onToggleMembershipModal={this.props.toggleMembershipModal}
      getMembershipNewRequests={this.props.getMembershipNewRequests}
    />
  )
  public ProcessedRequestsTableWrap = () => (
    <ProcessedRequestsTable
      currentOrgId={this.props.currentOrgId}
      items={this.props.items}
      onToggleMembershipModal={this.props.toggleMembershipModal}
      getMembershipProcessedRequests={this.props.getMembershipProcessedRequests}
    />
  )

  public render() {
    const activeTable = 'request-tab uppercase h5 py1 font-dark-grey cursor--pointer'
    return (
      <div className='member-ship py4'>
        <div className='flex items-center ml2'>
          <div className='flex bb-light-grey4'>
            <Link
              className={classNames(activeTable + ' mr4', {
                'bb-green': this.props.location.pathname === '/membership-requests/'
              })}
              to={`${this.props.match.path}/`}
            >
              New Requests
            </Link>
            <Link
              className={classNames(activeTable, {
                'bb-green': this.props.location.pathname === '/membership-requests/processed'
              })}
              to={`${this.props.match.path}/processed`}
            >
              Processed requests
            </Link>
          </div>
          <div className='ml-auto flex pb2 items-center px2'>
            <Search className='svg-white icon--small' />
            <div className='bg-grey py1 ml1 icon--small' />
          </div>
        </div>
        <Switch>
          <Route path={`${this.props.match.path}/`} exact={true} component={this.NewRequestsTableWrap} />
          <Route path={`${this.props.match.path}/processed`} component={this.ProcessedRequestsTableWrap} />
        </Switch>

        {this.props.isModalOpen && <MembershipSettings />}
      </div>
    )
  }
}

export default Membership



// WEBPACK FOOTER //
// ./src/components/membership-request/Membership.tsx